import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import React, { memo, useCallback, useState } from 'react';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { AdBannerMicrofrontendTgbContainer } from 'shared/containers/AdBannerMicrofrontendTgbContainer';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 376 };
const P_PARAMS_NEWBUILDING: AdfoxContextProviderProps['pParams'] = { p1: 'davxz', p2: 'fkhj' };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };

type TGBBannerProps = {
  isNewbuilding: boolean;
  position: number;
};

export const TGBBanner = memo<TGBBannerProps>(function TGBBanner(props) {
  const { isNewbuilding, position } = props;
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  const [isHidden, setIsHidden] = useState(false);
  const hide = useCallback(() => setIsHidden(true), []);

  if (manifest) {
    if (isHidden) {
      return null;
    }

    return (
      <AdBannerMicrofrontendTgbContainer
        manifest={manifest}
        position={position}
        isNewbuilding={isNewbuilding}
        onStub={hide}
        onError={hide}
        onClose={hide}
      />
    );
  }

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Adfox ТГБ баннер"
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
